import React from 'react';
import { useTranslation } from 'react-i18next';

// Types
import { ContainerProps } from './types';

// Styled Components
import { Container, IconError, Text } from './styles';

export const ErrorToast = ({ text, ...props }: ContainerProps) => {
  const { t } = useTranslation('common');
  return (
    <Container {...props}>
      <IconError>!</IconError>
      <Text size="M" variant="medium">
        {text || t('messages.error')}
      </Text>
    </Container>
  );
};
